import React, { useEffect, useState } from "react";
import { UseLockedBodyOutput } from "@/types/hooks";

export const useLockedBody = (initialLocked = false): UseLockedBodyOutput => {
  const [locked, setLocked] = useState(initialLocked);

  useEffect(() => {
    document.body.style.overflow = locked ? "hidden" : "";
  }, [locked]);

  return setLocked;
};
